// Client roster — rendered as a rolling credit sequence at the bottom of the page.
// Add or reorder freely.
export const clients = [
  "Dassault",
  "Meta",
  "Mastercard",
  "Shiprocket",
  "IFFA",
  "Taj Hotels & Resorts",
  "paisa lo",
  "AI Summit",
  "Sanofi",
  "Ministry of Information & Broadcast",
  "Ministry of Education",
];

// A few stat lines for the credits header
export const creditsMeta = {
  role: "DIRECTOR OF PHOTOGRAPHY / EDIT / STRATEGY",
  reel: "SELECTED CLIENTS 2019 — 2025",
};
